import { render, staticRenderFns } from "./ExemptionNew.vue?vue&type=template&id=0bad4938"
import script from "./ExemptionNew.vue?vue&type=script&lang=js"
export * from "./ExemptionNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports